"use client";
import React from "react";
import { BodyText } from "@/components/BodyText";

export default function Badge({
	children,
	className = "",
}: {
	children: React.ReactNode;
	className?: string;
}) {
	return (
		<span
			className={`font-poppins  select-none rounded-full !border-[1px]  !border-green-500 px-3 py-1 leading-5 text-[#16AB37] ${className}`}
		>
			{children}
		</span>
	);
}
